export const CHAT_LOADING = 'CHAT_LOADING' as const;
export const CHAT_LOADED = 'CHAT_LOADED' as const;
export const CHAT_LOADING_FAILED = 'CHAT_LOADING_FAILED' as const;

export const CHAT_UPDATE = 'CHAT_UPDATE' as const;
export const CHAT_POSTING = 'CHAT_POSTING' as const;
export const CHAT_POSTED = 'CHAT_POSTED' as const;
export const CHAT_POSTING_FAILED = 'CHAT_POSTING_FAILED' as const;

